import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import SectionHeader from "../../components/SectionHeader";
import HeaderImage from "../../images/main-banner.png";
import HeaderImage2 from "../../images/banner-side -image.png";
import VistaViewImage from "../../images/VistaView-Logo-B.png";
import SmartScreenMotorizedImage from "../../images/Smart-Screen-Logo-Motorized-B.png";
import SmartScreenImage from "../../images/Smart-Screen-Logo-B.png";
import { Col, Container, Row } from "react-bootstrap";
import Loading from "../../components/Loading ";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const WizardScreen = () => {
  const [loading, setLoading] = useState(true);
  const isLoggedIn = useSelector((state) => state.auth.user);
  const navigate = useNavigate();

  const products = [
    {
      id: "VistaView",
      slug: "vista-view",
      image: VistaViewImage,
      title: "Vista View",
      description:
        "VistaView™ Retractable Wall Screens are designed for even the biggest of doors and windows and the most unique applications. VistaView™ can cover up to 29’ wide and up to 11’ tall making it the largest Retractable screen available. You will love using VistaView™ screen doors for bi fold doors, stacker doors, curtain walls, telescoping walls, lift & slide door systems, french doors or any opening that needs to be screened.",
    },
    {
      id: "SmartScreenMotorized",
      slug: "smart-screen-motorized",
      image: SmartScreenMotorizedImage,
      title: "Smart Screen Motorized",
      description:
        "Wizard Screen Solutions introduces SmartScreen a versatile manual pull down screening system for windows, openings and garage doors. SmartScreen provides convenient insect control, UV protection, and feature a captured edge which prevents blow-outs.SmartScreen is the perfect solution for vertical screening. A unique floating track system provides smooth and easy operation. It takes only seconds to Slide n' Stop the screen anywhere along its tracks. Pin locks further secure the pull bar in place.",
    },
    {
      id: "SmartScreen",
      slug: "smart-screen",
      image: SmartScreenImage,
      title: "Smart Screen",
      description:
        "Wizard Screen Solutions introduces SmartScreen a versatile manual pull down screening system for windows, openings and garage doors. SmartScreen provides convenient insect control, UV protection, and feature a captured edge which prevents blow-outs.SmartScreen is the perfect solution for vertical screening. A unique floating track system provides smooth and easy operation. It takes only seconds to Slide n' Stop the screen anywhere along its tracks. Pin locks further secure the pull bar in place.",
    },
  ];

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  if (!isLoggedIn) {
    navigate("/login");
    return null;
  }

  if (loading) {
    return (
      <div className="spinner-container">
        <Loading />
      </div>
    );
  }

  return (
    <>
      <SectionHeader
        title="Wizard Screen"
        image={HeaderImage}
        image2={HeaderImage2}
        title2="Detail About Vendor"
        content=""
      />

      <Container className="aling">
        <Row>
          <Col md={12}>
            <div className="vista">
              {/* <Row> */}
                {products.map((product) => (
                  <Row className="product-card1" key={product.id}>
                    <Col sm={3} md={3}>
                      <div className="poduct-img">
                        <img src={product.image} alt={product.title} />
                        <Link to={`/quote-details/${product.slug}`}>
                          View Details
                        </Link>
                      </div>
                    </Col>
                    <Col sm={9} md={9}>
                      <div className="content">
                        <h2>{product.title}</h2>
                        <p>{product.description}</p>
                      </div>
                    </Col>
                  </Row>
                ))}
              {/* </Row> */}
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default WizardScreen;
